import React from 'react';

import { CheckIcon } from '../../shared/Icons';
import { ChipSelectLayout, ChipSelectOption } from './chipSelectTypes';
import { labelMarkup } from './chipSelectUtils';

interface ChipOptionButtonProps {
  option: ChipSelectOption;
  layout: ChipSelectLayout;
  multiple?: boolean;
  isSelected: boolean;
  interactive: boolean;
  onToggle: (value: string) => void;
}

const ChipOptionButton: React.FC<ChipOptionButtonProps> = ({
  option,
  layout,
  multiple,
  isSelected,
  interactive,
  onToggle,
}) => {
  const imageUrl = layout === 'chips' ? '' : option.imageUrl?.trim();
  const icon = option.icon?.trim();

  return (
    <button
      type="button"
      className={`chip-select-chip${isSelected ? ' is-selected' : ''}${
        imageUrl ? ' has-image' : ''
      }`}
      aria-pressed={multiple ? isSelected : undefined}
      aria-checked={multiple ? undefined : isSelected}
      role={multiple ? undefined : 'radio'}
      disabled={!interactive}
      onClick={() => interactive && onToggle(option.value)}
    >
      {imageUrl && (
        <span className="chip-select-media">
          <img src={imageUrl} alt={option.text || ''} loading="lazy" />
        </span>
      )}
      {icon && !imageUrl && (
        <span className="chip-select-icon" aria-hidden="true">
          {icon}
        </span>
      )}
      <span
        className="chip-select-label"
        dangerouslySetInnerHTML={{ __html: labelMarkup(option) }}
      />
      {layout !== 'chips' && (
        <span
          className={`chip-select-indicator${multiple ? ' is-square' : ''}`}
          aria-hidden="true"
        >
          <CheckIcon size={12} />
        </span>
      )}
    </button>
  );
};

export default ChipOptionButton;
